module.exports = __webpack_public_path__ + "img/checkin_gracias.5203b7df.svg";